<template>
  <div class="mx-md-12 px-sm-12 align--center text-justify">
    <br>
    <p class="display-1">Impressum/Offenlegung/&sect; 13 AVG/Allgemeine Nutzungsbedingungen f&uuml;r Gemeindehomepages</p>
    
    <p class="title">1. Impressum/Offenlegung gem. &sect;&sect; 24f MedienG</p>

    Medieninhaber:
    Marktgemeinde Frankenburg am Hausruck 

    <br>
    Herausgeber: 

    Marktgemeinde Frankenburg am Hausruck<br>
    Ansprechperson: Herr Zweim&uuml;ller<br>
    Adresse: Marktplatz 4<br>
    Telefon: 07683/5006-0<br>
    Fax: 07683/5006-14<br>
    E-Mail: gemeinde@frankenburg.ooe.gv.at<br>
    DVR-Nummer der Marktgemeinde Frankenburg am Hausruck: 0095559 

    <br>
    Medienlinie gem. &sect; 25 Abs. 4 MedienG: Marktgemeinde Frankenburg am Hausruck

    <br>
    Homepage des Altenheimes der Marktgemeinde Frankenburg am Hausruck bietet der &Ouml;ffentlichkeit Informationen und E-Government Dienste der Marktgemeinde Frankenburg am Hausruck 

    <br>
    <br>
    <p class="title">2. Kundmachung gem. &sect; 13 AVG</p>

    Schreiben an die Marktgemeinde Frankenburg am Hausruck richten Sie bitte an folgende Adresse: Marktplatz 4, 4873 Frankenburg am Hausruck 

    Zur leichteren Bearbeitung Ihres Schreibens ersuchen wir Sie, falls bekannt, die Gesch&auml;ftszahl anzuf&uuml;hren. 

    Telefon und Fax

    <br>
    Bei &Uuml;bermittlungen per Telefax verwenden Sie bitte die Telefax-Nummer 07683/5006-14. F&uuml;r telefonische Anfragen stehen wir unter der Telefonnummer 07683/5006-0 w&auml;hrend der Amtsstunden zur Verf&uuml;gung. 

    E-Mail

    Wenn Sie mit uns elektronisch kommunizieren wollen, verwenden Sie bitte die offizielle E-Mail Postadresse gemeinde@frankenburg.ooe.gv.at der Marktgemeinde Frankenburg am Hausruck. 

    F&uuml;r die elektronische Kommunikation mit der Marktgemeinde Frankenburg am Hausruck k&ouml;nnen folgende Formate verwendet werden: 

    <br>

    Text ASCII text/plain *.TXT <br>
    Dokument PDF application/pdf *.PDF <br>
    RTF application/rtf *.RTF <br>
    MS Office Word application/msword *.DOC <br>
    MS Office Excel application/msexcel *.XLS <br>
    Grafik GIF image/gif *.GIF <br>
    JPEG image/jpeg *.JPG *.JPEG <br>
    BMP image/bmp *.BMP <br>
    HTML HTML text/html *.HTM *.HTML <br>
    Komprimierung ZIP application/zip *.ZIP <br>

    <br>
    <br>
    <p class="title">3. Allgemeine Nutzungsbedingungen</p>

    Der Nutzer anerkennt, dass die Nutzung der von der Marktgemeinde Frankenburg am Hausruck angebotenen Dienste im Internet ausschlie&szlig;lich unter Anwendung dieser allgemeinen Nutzungsbedingungen erfolgt. 

    Der Nutzer nimmt zur Kenntnis, dass die Marktgemeinde Frankenburg am Hausruck keine Verpflichtung &uuml;bernimmt, die von ihr im Internet angebotenen Dienste unterbrechungsfrei und jederzeit abrufbar zu halten. 

    Sowohl die Zurverf&uuml;gungstellung als auch die Nutzung der Dienste und Inhalte unterliegen den einschl&szlig;gigen gesetzlichen Regelungen insbesondere des Datenschutzes, des Urheberrechts sowie des Marken- und Musterschutzes. 

    Die auf den Internetseiten der Marktgemeinde Frankenburg am Hausruck wiedergegebenen Inhalte dienen, trotz eingehender Recherche und Aufarbeitung, lediglich zur Information. F&uuml;r dennoch enthaltene Fehler kann keine wie immer geartete Haftung &uuml;bernommen werden. Weiters erkl&auml;rt sich die Marktgemeinde Frankenburg am Hausruck als nicht verantwortlich f&uuml;r den Inhalt von Internetseiten, auf die mit einem Link verwiesen wird.
  </div>
</template>


<script>
export default {
}
</script>

<style>
.div{
  padding:10px;
}
</style>